// @flow strict
// Navigating to an identical URL with a #fragment can remain in the same document.
// A normal retry click must reload, while modified clicks retain native link behavior.
export default function reloadPageOnClick(event, pageWindow = window) {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    !pageWindow
  )
    return;
  event.preventDefault();
  pageWindow.location.reload();
}
